module.exports = __webpack_public_path__ + "img/home-page-logos.32b293ff.png";